import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=66b8554e&scoped=true"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=66b8554e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b8554e",
  null
  
)

export default component.exports